// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5660":"d4c86c13b2b4908d","9826":"171962b56268bec0"}[chunkId] + ".js";
};